<script setup lang='ts'>
import type { InputHTMLAttributes, PropType } from 'vue';

const emit = defineEmits(['update:modelValue']);

const updateValue = (event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement)?.value || '');
};

const props = defineProps({
  placeholder: String,
  label: String,
  modelValue: String,
  password: Boolean,
  type: {
    type: String as PropType<InputHTMLAttributes['type']>,
    default: 'text'
  },
  valid: {
    type: Boolean,
    default: true
  }
});
</script>

<template>
  <fieldset>
    <transition
      enter-active-class="transition-all ease-in-out transform"
      leave-active-class="transition-all ease-in transform"
      enter-from-class="-translate-x-4 opacity-0"
      enter-to-class="translate-x-0 opacity-60"
      leave-to-class="-translate-x-4 opacity-0"
    >
      <legend
        v-if="props.modelValue"
        class="absolute text-sm pl-3 pt-1 text-white text-opacity-60"
      >
        {{ props.label }}
      </legend>
    </transition>
    <input
      :type="type"
      class="w-full border-1 focus:border-2 rounded-xl border-onboard-shade1 focus:border-onboard-shade2 bg-onboard-background text-center outline-none h-16"
      :class="!valid && 'border-red-500'"
      :placeholder="props.placeholder"
      :value="modelValue"
      @input="updateValue"
      autocomplete="new-password"
    />
  </fieldset>
</template>

